import { useEffect, useState, useMemo } from 'react'
import { BiSearch } from 'react-icons/bi'
import styled from 'styled-components'
import { IoIosClose } from 'react-icons/io'
import OtcInput from './Input'
import CoinSearchRow from './CoinSearchRow'
import { useGetSwapSettings } from '../core/useSwap'
import { ScaleLoader } from 'react-spinners'
import { Text, useMainContext } from '../../Dashboard'
import { useMarketQuery } from '../../../core/services/react-query/useMarketQuery'
import { DText } from '../../../styles/CommonStyles'
import { IconWrapper } from '../../../styles/CoinOperationStyles'

const deepCopy = (obj) => (obj ? JSON.parse(JSON.stringify(obj)) : null)

const SelectCoin = ({ onClose, type, onChange, gold }) => {
    const {
        main: { lang },
    } = useMainContext()

    const { data: _prices, isLoading: loadingPrices } = useMarketQuery()
    const { data: swapSettings, isLoading: loadingSwapSetting } = useGetSwapSettings()

    const [coins, setCoins] = useState([])
    const [search, setSearch] = useState('')

    // Build allowed currency list from swap settings
    const allowedCurrencies = useMemo(
        () => swapSettings?.currencies?.map((c) => c.currency?.toLowerCase()) || [],
        [swapSettings]
    )

    useEffect(() => {
        if (_prices && allowedCurrencies.length) {
            let filtered = _prices.filter((p) =>
                allowedCurrencies.includes(p.id?.toLowerCase())
            )

            if (gold) {
                filtered = filtered.filter(
                    (i) => i.name === 'Gold' || i.name === 'Dollar'
                )
            }

            if (search) {
                filtered = filtered.filter((item) =>
                    [item.id, item.fa, item.name?.toLowerCase()].some((field) =>
                        field?.includes(search.toLowerCase())
                    )
                )
            }

            setCoins(deepCopy(filtered))
        }
    }, [_prices, allowedCurrencies, gold, search])

    const onSearch = (e) => {
        setSearch(e?.target?.value || '')
    }

    const onCoinChange = (item) => {
        onChange(item)
        onClose()
    }

    const isLoading = loadingPrices || loadingSwapSetting

    return (
        <div className="flex flex-col" dir={lang === 'fa' ? 'rtl' : 'ltr'}>
            <OtcInput
                icon={<SearchIcon size={24} />}
                value={search}
                onChange={onSearch}
                label={lang === 'fa' ? 'جستجو' : 'Search'}
                width={'95%'}
            />
            {

                isLoading ? <div className='w-full flex justify-center items-center h-32'>
                    <ScaleLoader color='#39d1ae' height='18px' width='2px' />
                </div> :
                    <CoinListWrapper>
                        {coins.map((item) => (
                            <CoinSearchRow
                                key={item.id}
                                coin={item}
                                type={type}
                                onClick={() => onCoinChange(item)}
                            />
                        ))}
                    </CoinListWrapper>
            }
        </div>
    )
}

const SearchIcon = styled(BiSearch)`
    color: ${(props) => props.theme.color};
`

const CoinListWrapper = styled.div`
    height: 65vh;
    width: 100%;
    overflow-y: auto;
`

const CloseIcon = styled(IoIosClose)`
    color: ${(props) => props.theme.primary};
`

export default SelectCoin
